import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { GA_MEASUREMENT_ID, trackGaEvent, trackPageView } from "@/lib/analytics";

/**
 * Tracks SPA navigations after the initial page_view from index.html gtag.
 */
export function GoogleAnalytics() {
  const location = useLocation();
  const isFirstRoute = useRef(true);

  useEffect(() => {
    if (!GA_MEASUREMENT_ID) return;

    const pagePath = location.pathname + location.search;

    if (isFirstRoute.current) {
      isFirstRoute.current = false;
      return;
    }

    trackPageView(pagePath);
  }, [location.pathname, location.search]);

  return null;
}

/** @deprecated Use trackGaEvent from @/lib/analytics */
export function gtagEvent(
  eventName: string,
  params?: Record<string, string | number | boolean | null>
) {
  trackGaEvent(eventName, params);
}

export function gtagConversion(
  eventName: string,
  value?: number,
  currency: string = "USD",
  transactionId?: string
) {
  trackGaEvent(eventName, {
    value,
    currency,
    transaction_id: transactionId || undefined,
  });
}
